'use client'
import { Container } from 'components/Container'
import { Overline } from 'components/Overline'
import Tag from 'components/Tag'
import { Locale } from 'i18n/routing'
import { trackGoal } from 'lib/analytics'
import { useLocale, useTranslations } from 'next-intl'
import { useState } from 'react'

type Topic = { de: string; en: string }

const topics: Topic[] = [
  { de: 'Architektur', en: 'Architecture' },
  { de: 'User Experience', en: 'User Experience' },
  { de: 'User Interface', en: 'User Interface' },
  { de: 'Prototyping', en: 'Prototyping' },
  { de: 'Web & Mobile Apps', en: 'Web & Mobile Apps' },
  { de: 'Website & CMS', en: 'Website & CMS' },
  { de: 'APIs', en: 'APIs' },
  { de: 'Datenbanken', en: 'Databases' },
  { de: 'Betrieb', en: 'Operation' },
  { de: 'Wartung', en: 'Maintenance' },
  { de: 'Datensicherheit', en: 'Data Security' },
  { de: 'Audits', en: 'Audits' },
]

export function BlogPoll() {
  const [chosenTopics, setChosenTopics] = useState<Topic[]>([])
  const t = useTranslations('blogPoll')
  const locale = useLocale() as Locale

  const chooseTopic = (topic: Topic) => {
    setChosenTopics((currentTopics) => [topic, ...currentTopics])
    trackGoal('blogTopic', { props: { voted: topic.de } })
  }

  return (
    <section className="bg-blue">
      <Container width="narrow" className="md:px-160 px-48 md:py-160 py-80">
        <div className="mb-64">
          <Overline>{t('survey')}</Overline>
          <h2 className="h3">{t('interest')}</h2>
        </div>
        <div className="flex flex-wrap">
          {topics.map((topic) => {
            const active = chosenTopics?.includes(topic)
            return (
              <button
                disabled={active}
                className="mr-16 mb-16"
                key={topic.de}
                onClick={() => chooseTopic(topic)}
              >
                <Tag active={active}>{topic[locale]}</Tag>
              </button>
            )
          })}
        </div>
      </Container>
    </section>
  )
}
